"use client";

import { Label as LabelPrimitive } from "radix-ui";
import * as React from "react";

import { cn } from "@/lib/utils";

const LabelRoot = LabelPrimitive.Root as unknown as React.ComponentType<
	React.ComponentPropsWithoutRef<"label"> & React.RefAttributes<HTMLLabelElement>
>;

const Label = React.forwardRef<HTMLLabelElement, React.ComponentPropsWithoutRef<"label">>(
	({ className, ...props }, ref) => {
		return (
			<LabelRoot
				ref={ref}
				data-slot="label"
				className={cn(
					"flex items-center gap-2 text-sm leading-none font-medium select-none group-data-[disabled=true]:pointer-events-none group-data-[disabled=true]:opacity-50 peer-disabled:cursor-not-allowed peer-disabled:opacity-50",
					className,
				)}
				{...props}
			/>
		);
	},
);

Label.displayName = LabelPrimitive.Root.displayName;

export { Label };
